import React, {useEffect, useState, useRef} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileExport
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import dayjs from 'dayjs';
import PendingUserList from './component/PendingUserList';
import * as _ from 'lodash';
import { toast } from 'react-toastify';
import { socket } from '../../socket';
import ReportTable from './component/ReportTable';
import SearchForm from './component/SearchForm';
import CardReport from './component/CardReport';
import './Agent.css';
import { Pagination, notification, Space } from 'antd';

const Agent = () => {
    const [api, contextHolder] = notification.useNotification();

    const api_base_url = process.env.REACT_APP_API_URL;

    const sound_url = api_base_url+'public/chatwidget/music/incoming-call-request.mp3';
    const audio = new Audio(sound_url);
    audio.loop = true;

    const agentInfo = JSON.parse(localStorage.getItem('agentInfo'));

    const [pendingUser, setpendingUser] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [liveUser, setLiveUser] = useState([]);
    const [isAccepted, setIsAccepted] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [onlineAgents, setOnlineAgents] = useState([]);

    const [timezoneData, setTimezoneData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [selectedTimezone, setSelectedTimezone] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const dataLimit = 20;

    const [open, setOpen] = useState(false);

    const [summaryData, setSummaryData] = useState({
        totalSession: 0,
        totalAttended: 0,
        totalRejected: 0,
        totalTransfer: 0,
        totalDuration: 0,
        uniqueIp: 0,
    })
	
    useEffect(() => {
        socket.connect();
        const getSessionList = async(status) => {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('agenttoken')
                }
            };
            await axios.post(`${api_base_url}agent/session-list`, { agent_id: agentInfo.unique_id, status: status}, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        if(status == 'waiting') {
                            setpendingUser(res.data.data);
                        } else {
                            setLiveUser(res.data.data);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        const getActiveAgent = async() => {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('agenttoken')
                }
            };
            await axios.post(`${api_base_url}agent/get-online-agent`, { agent_id: agentInfo.unique_id}, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setOnlineAgents(res.data.data);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        setSelectedTimezone(new Date().getTimezoneOffset());
        getSessionList("waiting");
        getSessionList("live");
        getActiveAgent();
        getAcceptedSessionList();
        getAllTimeZone();
        socket.emit("agent_join", agentInfo.unique_id);
        socket.on("web_agent_session_create", (data)=>{
            setpendingUser((prevState)=>[ ...prevState, data]);
            openNotification(data);
        });
        socket.on("web_agent_session_remove", (data)=>{
            if(data) {
                setLiveUser((prevItems) => prevItems.filter((item) => item.session_id !== data.session_id));
                //setSelectedUser((items) => items.map((item) => item.session_id == data.session_id));
            }
        });
        socket.on("user_remove", (data)=>{
            if(data) {
                getAcceptedSessionList();
                setLiveUser((prevItems) => prevItems.filter((item) => item.session_id !== data.session_id));
            }
        });
        socket.on("agent_online", (agent_data)=>{
            if(agent_data.value != agentInfo.unique_id) {
                setOnlineAgents(prevState => ([...prevState, ...agent_data]));
            }
        });
        socket.on("agent_offline", (data)=>{
            setOnlineAgents((prevItems) => prevItems.filter((item) => item.value !== data.unique_id));
        })

        return () => {
            socket.off("web_agent_session_create");
            socket.off("web_agent_session_remove");
            socket.off("user_remove");
            socket.off("agent_online");
            socket.off("agent_offline");
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        if(open) {
            audio.play().catch((error) => console.error("Error playing sound:", error));;
            setTimeout(() => {
                audio.pause();
            }, 60000);
        }
        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, [open]);

    const getAllTimeZone = async() => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        
        await axios.post(`${api_base_url}agent/get-all-timezone`, {}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const result = res.data.data.map((item, index) => ({
                    label: item.timezone,
                    value: item.operator+item.offset_in_min
                }));
                setTimezoneData(result);
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const sessionAcceptedHandeler = async(session_id) => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        await axios.post(`${api_base_url}agent/session-accept`, { session_id: session_id, agent_id: agentInfo.unique_id }, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    var single_session = {
                        created_at: res.data.data.created_at,
                        duration: "00:00:00",
                        email: res.data.data.email,
                        mobile_number: null,
                        name: res.data.data.name,
                        receiver_id: res.data.data.receiver_id,
                        room: res.data.data.room,
                        sessionId: res.data.data.session_id,
                        transfer_by: "Our Bot",
                        transfer_on: res.data.data.transfer_on,
                        updated_at: res.data.data.updated_at,
                        user_source: res.data.data.user_source
                    }
                    setpendingUser((prevItems) => prevItems.filter((item) => item.session_id !== session_id));
                    setLiveUser(prevData => [...prevData, res.data.data]);
                    setTableData(prevData => [...prevData, single_session]);
                    setIsAccepted(true)
                    setSelectedUser(single_session);

                    if(audio) {
                        audio.pause();
                    }
                    setOpen(false);
                    api.destroy();
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const sessionRejectedHandeler = async(session_id) => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        await axios.post(`${api_base_url}agent/session-reject`, { session_id: session_id, agent_id: agentInfo.unique_id }, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setpendingUser((prevItems) => prevItems.filter((item) => item.session_id !== session_id));

                    if(audio) {
                        audio.pause();
                    }
                    setOpen(false);
                    api.destroy();
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const getAcceptedSessionList = async(event, page_no) => {
        const api_params = {};
        if(event) {
            setSelectedTimezone(event.timeOffset);
            setSelectedStartDate(event.searchStartDate);
            setSelectedEndDate(event.searchEndDate);

            api_params.searchStartDate = event.searchStartDate;
            api_params.searchEndDate = event.searchEndDate;
            api_params.ip_address = event.ip_address;
            api_params.timeOffset = event.timeOffset;
        } else {
            if(selectedStartDate && selectedEndDate && selectedTimezone) {
                api_params.searchStartDate = selectedStartDate;
                api_params.searchEndDate = selectedEndDate;
                api_params.ip_address = '';
                api_params.timeOffset = selectedTimezone;
            } else {
                var s_date = dayjs().startOf('day');
                var start_date = new Date(s_date).toLocaleString("en-GB");
                var split_start_data = start_date.split(", ");

                const [day, month, year] = split_start_data[0].split('/');

                const formattedStartDate = `${year}-${month}-${day} ${split_start_data[1]}`;
                setSelectedStartDate(formattedStartDate);
                api_params.searchStartDate = formattedStartDate;

                var e_date = dayjs().endOf('day');
                var end_date = new Date(e_date).toLocaleString("en-GB");
                var split_end_data = end_date.split(", ");

                const [e_day, e_month, e_year] = split_end_data[0].split('/');

                const formattedEndDate = `${e_year}-${e_month}-${e_day} ${split_end_data[1]}`;
                setSelectedEndDate(formattedEndDate);
                api_params.searchEndDate = formattedEndDate;
            
                setSelectedTimezone(new Date().getTimezoneOffset());
                api_params.timeOffset = new Date().getTimezoneOffset();
                api_params.ip_address = '';
            }
        }
        api_params.sass_id = localStorage.getItem('sass_id');
        api_params.agent_id = agentInfo.unique_id;
        api_params.page = page_no ? page_no : page;
        api_params.limit = dataLimit;

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        setShowLoader(true);
        await axios.post(`${api_base_url}agent/accepted-session-list`, api_params, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setTableData(res.data.data.session_data);

                    if(res.data.data.summary_data) {
                        const duration = res.data.data.summary_data.total_duration;
                        var final_duration = '';
                        if(duration){
                            const [hours, minutes, seconds] = duration.split(":");
                            if(hours != '00'){
                                final_duration += hours+" hr ";
                            }
                            if(minutes != '00'){
                                final_duration += minutes+" min";
                            }
                        }
    
                        setSummaryData((prevState)=>{
                            return {
                                ...prevState,
                                totalSession: res.data.data.summary_data.total_session,
                                totalAttended: res.data.data.summary_data.total_attended,
                                totalRejected: res.data.data.summary_data.total_rejected,
                                totalTransfer: res.data.data.summary_data.total_transfer,
                                totalDuration: final_duration,
                                uniqueIp: res.data.data.summary_data.unique_ip
                            }
                        });
                    }
                    setTotalRecord(res.data.data.total_count);
                    setShowLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setShowLoader(false);
            })
    }

    const onChange = (page) => {
        setPage(page);
        getAcceptedSessionList(null, page);
    };

    var total_record = 0;
    var total_page = 0;
    var page_no = 0;
    const limit = 20;

    var type = "data_count";
    var exportType = '';

    const handleExport = async() => {
        const api_params = {};
        api_params.searchStartDate = selectedStartDate;
        api_params.searchEndDate = selectedEndDate;
        api_params.timeOffset = selectedTimezone;
        api_params.sass_id = localStorage.getItem('sass_id');
        api_params.agent_id = agentInfo.unique_id;
        api_params.limit = limit;
        api_params.type = type;
        api_params.exportType = exportType;

        api_params.page = page_no;
        api_params.total_page = total_page;

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        await axios.post(`${api_base_url}agent/get-all-data-for-csv`, api_params, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    if(type === "data_count") {
                        total_record = parseInt(res.data.data.total_data_count);

                        var remainder = (total_record % limit);
                        var quotient = Math.floor(total_record / limit);
                        if(remainder == 0) {
                            total_page = quotient;
                        } else {
                            total_page = (quotient + 1);
                        }
                    }
                    
                    if(total_page > page_no) {
                        type = "data_export";
                        exportType = total_page > 1 ? "multiple" : "";
                        page_no += 1;
                        handleExport();
                    } else {
                        if(res.data.data.is_completed == "yes"){
                            downloadCSV(res.data.data);
                        }
                    }
                }
            })
            .catch((error) => {
                setShowLoader(false);
            })
    };
    const downloadCSV = (data) => {
        const url = api_base_url+data.zip_folder_path;
      
        const link = document.createElement("a");
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(()=>{
            page_no = 0;
            deleteDownloadedFile(data.zip_folder_path);
        },3000)
    };
    const deleteDownloadedFile = async(link) => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        await axios.post(`${api_base_url}agent/unlink-all-type-file`, {unlink_file_path: link}, api_headers)
            .then(async (res) => {})
            .catch((error) => {})
    }

    const openNotification = (data) => {
        setOpen(true);
        const btn = (
          <Space>
            <button className='btn btn-danger me-4' onClick={()=>sessionRejectedHandeler(data.session_id)}>Reject</button>
            <button className='btn btn-success' onClick={()=>sessionAcceptedHandeler(data.session_id)}>Accept</button>
          </Space>
        );
        api.open({
            message: 'Agent Assistance Needed',
            description:
                `A conversation has been escalated for your attention. Please review the chat and address the customer's query promptly.`,
            btn,
            closeIcon: false,
            onClose: ()=>closeNotification(data.session_id),
            duration: 60
        });
    };

    const closeNotification = async(session_id) => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        await axios.post(`${api_base_url}agent/miss-session`, { session_id: session_id, agent_id: agentInfo.unique_id }, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setpendingUser((prevItems) => prevItems.filter((item) => item.session_id !== session_id));
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }

    return (
        <>
        {contextHolder}
        <div className="row mb-5">
            <CardReport title={summaryData.totalSession} sub_title="Total Session" className="tv-light-dark" title_color="text-dark fs-4x me-6" />
            <CardReport title={summaryData.totalAttended} sub_title="Attended" className="tv-light-success" title_color="text-success fs-4x me-6" />
            <CardReport title={summaryData.totalRejected} sub_title="Rejected" className="tv-light-danger" title_color="text-danger fs-4x me-6" />
            <CardReport title={summaryData.totalTransfer} sub_title="Transferred" className="tv-light-warning" title_color="text-warning fs-4x me-6" />
            <CardReport title={summaryData.totalDuration ? summaryData.totalDuration : 0} sub_title="Duration" className="tv-light-primary" title_color={`text-primary word-break ${summaryData.totalDuration == 0 ? 'fs-4x' : 'fs-2x'}`} />
            <CardReport title={summaryData.uniqueIp} sub_title="Unique" className="tv-light-info" title_color="text-info fs-4x me-6" />
        </div>
        <div className='row'>
            {pendingUser.map((item, index) => <PendingUserList item={item} key={index} sessionAccepted={sessionAcceptedHandeler} sessionRejected={sessionRejectedHandeler} />)}
        </div>
        <SearchForm timeZone={timezoneData} searchReport={getAcceptedSessionList} loaderStatus={showLoader} />
        <div className='row'>
            <div className='col-md-12'>
                <div className='card card-flush'>
                    <div className="card-header pe-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-gray-800 fs-2">
                                Session History
                            </span>
                            <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                Total {tableData.length} chat session are available
                            </span>
                        </h3>
                        <div className='card-toolbar'>
                            {tableData.length > 0 && <button type="button" className="btn btn-dark btn-sm" onClick={handleExport}>
                                <FontAwesomeIcon icon={faFileExport} /> CSV Export
                            </button>}
                        </div>
                    </div>
                    <div className='card-body py-0'>
                        <ReportTable tableRow={tableData} liveUsers={liveUser} accept={isAccepted} selected_user={selectedUser} allAgents={onlineAgents} />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-5">
            <Pagination 
                align="end" 
                defaultPageSize={20}
                defaultCurrent={1} 
                current={page} 
                onChange={onChange}
                total={totalRecord}  
                hideOnSinglePage={true}
            />
        </div>
        </>
    )
}

export default Agent